module.exports = __webpack_public_path__ + "static/media/zhangyuxi.b7985b79.png";